import type { TersaImageModel } from '../types';
import { providers } from '../../providers';
import { wavespeed } from '../wavespeed';

// 系数
const COST_FACTOR = 1.5;

export const topazModels: Record<string, TersaImageModel> = {
    'topaz/image/sharpen': {
        chef: providers.topaz,
        providers: [
            {
                ...providers.topaz,
                model: wavespeed.image('topaz/image/sharpen'),
                getCost: () => 0.15 * COST_FACTOR,
            },
        ],
        hideInstructions: true,
        tags: ['image-effects'],
        configByMode: {
            i2i: {
                sizes: [],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            i2i: ['image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'topaz/image/restore': {
        chef: providers.topaz,
        providers: [
            {
                ...providers.topaz,
                model: wavespeed.image('topaz/image/restore'),
                getCost: () => 0.15 * COST_FACTOR,
            },
        ],
        hideInstructions: true,
        tags: ['image-effects'],
        configByMode: {
            i2i: {
                sizes: [],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            i2i: ['image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'topaz/image/lighting': {
        chef: providers.topaz,
        providers: [
            {
                ...providers.topaz,
                model: wavespeed.image('topaz/image/lighting'),
                getCost: () => 0.15 * COST_FACTOR,
            },
        ],
        hideInstructions: true,
        tags: ['image-effects'],
        configByMode: {
            i2i: {
                sizes: [],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            i2i: ['image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'topaz/image/denoise': {
        chef: providers.topaz,
        providers: [
            {
                ...providers.topaz,
                model: wavespeed.image('topaz/image/denoise'),
                getCost: () => 0.15 * COST_FACTOR,
            },
        ],
        hideInstructions: true,
        tags: ['image-effects'],
        configByMode: {
            i2i: {
                sizes: [],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            i2i: ['image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};